import React from "react";
import PropTypes from "prop-types";

const ProfileArchiveReason = ({ reason }) => (
  <div className="profile-right-nav profile-reason">
    <h3>Reason To Become a Chimney</h3>
    <div>{reason}</div>
  </div>
);

export default ProfileArchiveReason;
